import { configureStore } from "@reduxjs/toolkit";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
// import { persistConfig } from "./persistConfig";
import { posPersistConfig } from "./persistConfig";
import combineReducers, { getReducerMiddlewares } from "./reducer";
import { vendorSyncMiddleware } from "utils/vendorSync";

export const combinedReducers = combineReducers();

const persistedReducer = persistReducer(posPersistConfig, combinedReducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
        .concat(vendorSyncMiddleware)
        .concat(...getReducerMiddlewares());
    },

});



export const persistor = persistStore(store);